// Versioni e data di efficacia dei documenti legali.
// I valori devono combaciare ESATTAMENTE con quanto mostrato in /privacy e /termini
// e con i valori salvati nel DB (privacy_version / terms_version).
export const PRIVACY_VERSION = '2026-07-07';
export const TERMS_VERSION = '2026-07-07';
export const LEGAL_EFFECTIVE_DATE = '7 luglio 2026';

// Indirizzo ufficiale per privacy, diritti GDPR e contatti legali.
export const PRIVACY_EMAIL = 'privacy@uptra.app';

// Gate di ri-accettazione per utenti esistenti: OFF al lancio.
// Da attivare solo dopo la revisione legale dei testi.
export const REQUIRE_LEGAL_ACCEPT = false;

// Oggetto consenso da passare a signUp() al momento della registrazione.
export const buildConsentPayload = () => {
  const now = new Date().toISOString();
  return {
    privacy_read_at: now,
    privacy_version: PRIVACY_VERSION,
    terms_accepted_at: now,
    terms_version: TERMS_VERSION,
  };
};

// PB-002 — Consenso "pending" per il login OAuth: lo stato del form si perde nel
// redirect verso il provider, quindi il consenso spuntato prima del click viene
// salvato in localStorage e riscritto sul profilo al ritorno.
const PENDING_CONSENT_KEY = 'uptra_pending_consent';

export const markPendingConsent = () => {
  try { localStorage.setItem(PENDING_CONSENT_KEY, JSON.stringify(buildConsentPayload())); } catch (e) { /* storage bloccato */ }
};

export const readPendingConsent = () => {
  try { const v = localStorage.getItem(PENDING_CONSENT_KEY); return v ? JSON.parse(v) : null; } catch (e) { return null; }
};

export const clearPendingConsent = () => {
  try { localStorage.removeItem(PENDING_CONSENT_KEY); } catch (e) { /* no-op */ }
};
